export default __webpack_public_path__ + "8df6ee4f653598985061b3692b77cd0a.svg";